import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table/table.component';
import { MatFormFieldComponent } from './mat-form-field/mat-form-field.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { PagingComponent } from './paging/paging.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DirectiveModule } from '../directives/directive.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { CalendarChooserComponent } from './calendar-chooser/calendar-chooser.component';
import { ContentVideoUploadComponent } from './content-video-upload/content-video-upload.component';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		TableComponent,
		MatFormFieldComponent,
		OverlayModule,
		FormsModule,
		PipesModule,
		PagingComponent,
		EmptyStateComponent,
		MatButtonModule,
		MatIconModule,
		DirectiveModule,
		MatProgressSpinnerModule,
		MatFormFieldModule,
		MatInputModule,
		CalendarChooserComponent,
		ContentVideoUploadComponent
	],
	exports: [
		CommonModule,
		TableComponent,
		MatFormFieldComponent,
		OverlayModule,
		FormsModule,
		PipesModule,
		PagingComponent,
		EmptyStateComponent,
		MatButtonModule,
		MatIconModule,
		DirectiveModule,
		MatProgressSpinnerModule,
		MatFormFieldModule,
		MatInputModule,
		CalendarChooserComponent,
		ContentVideoUploadComponent
	],
})
export class SharedModule {}
